import * as React from 'react'
import { FC } from 'react'
import { Formik } from 'formik'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { AddNoteFormFieldsModalForm } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/AddNoteFormFieldsModalForm'
import { usePestPacNoteOptionsSelector } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/hooks/useNoteLocationSelector'
import { useHandlers } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/hooks/useHandlers'
import Stack from '@mui/material/Stack'

interface Props {
  entityId: number
  externalLocationId: string
  entityType: ENTITY_TYPES
  onClose: () => void
  onUpdateSuccess?: () => void
  onGoBack?: () => void
  currentServiceLocation?: LocationDTO
}

export const AddNoteFormWrapper: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    onClose,
    externalLocationId,
    onUpdateSuccess,
    onGoBack,
    currentServiceLocation,
  } = props
  const { serviceLocations, serviceOptions, noteCodes } =
    usePestPacNoteOptionsSelector()

  const { onSubmitLeadNote, validate } = useHandlers({
    entityId,
    entityType,
    onUpdateSuccess,
    onClose,
    onGoBack,
    serviceOptions: serviceLocations || [],
  })

  return (
    <Stack minHeight={'150px'}>
      {!externalLocationId ||
      (serviceOptions.length > 0 && noteCodes.length > 0) ? (
        <Formik
          onSubmit={onSubmitLeadNote}
          validate={validate}
          initialValues={{
            detail: '',
            title: '',
            addNotesToPestPac: Boolean(externalLocationId),
            serviceLocation: currentServiceLocation?.id.toString()
              ? serviceOptions.find(
                  (row) => row.value === currentServiceLocation?.id?.toString(),
                )?.value
              : serviceOptions?.length === 1
                ? serviceOptions[0].value
                : '',
            code: noteCodes.find((code) => code.isDefault)?.name,
          }}
        >
          <AddNoteFormFieldsModalForm
            externalLocationId={externalLocationId}
            serviceOptions={serviceOptions?.filter((row) => {
              if (currentServiceLocation?.id?.toString()) {
                return row.value === currentServiceLocation?.id?.toString()
              }
              return true
            })}
            noteCodes={noteCodes}
          />
        </Formik>
      ) : null}
    </Stack>
  )
}

AddNoteFormWrapper.displayName = 'AddNoteFormWrapper'
